import styled from '@emotion/styled'

interface IContainerProps {
  height: number
  width: number
}

export const Container = styled.div<IContainerProps>`
  height: 0;
  padding: 0;
  padding-bottom: ${({ height, width }) => `${(height / width) * 100}%`};
  position: relative;
  width: 100%;
`

export const SVG = styled.svg`
  fill: transparent;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`
